import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

/**
 * Small keyboard-shortcut hint pill, e.g. `⌘K`, `N`, `?`. Matches the
 * mockup `.cmd-kbd` / `.sb-cap-kbd` styles.
 */
export interface KbdHintProps extends HTMLAttributes<HTMLElement> {
  size?: 'sm' | 'md';
}

export const KbdHint = forwardRef<HTMLElement, KbdHintProps>(function KbdHint(
  { size = 'md', className, children, ...rest },
  ref,
) {
  const sizeCls =
    size === 'sm' ? 'text-2xs px-1 py-[1px] rounded-sm' : 'text-2xs px-1.5 py-[2px] rounded';

  return (
    <kbd
      ref={ref}
      className={cn(
        'inline-flex shrink-0 items-center justify-center border border-line bg-rail font-mono text-t2 leading-none',
        sizeCls,
        className,
      )}
      {...rest}
    >
      {children}
    </kbd>
  );
});
